<template>
    <div class="formsect">
        <div v-if="res == 0">
            <div class="inline">
                <h2 v-if="obj.productDetails.featureSet == 1">Classic card</h2>
                <h2 v-else>Travel card</h2>
                <h3>
                    <strong>{{toFixed(parseFloat(obj.productDetails.APR), 1)}}% </strong>
                    {{text[0]}}
                </h3>
                <img alt="" :src="require(`@/v1/assets/images/${obj.productDetails.cardDesignName}.png`)"/>
            </div>
            <div class="inline">
                <button class="applyNowBtn" @click="applyNow(obj.productId, id, token, url)">Apply</button>
                <ticklist :obj="genBullets(obj.productDetails)"></ticklist>
            </div>
            <div class="examplerep" v-if="bin == 'true'">
                <h4>Representative example:</h4>
                <p>{{text[1]}} {{toFixed(parseFloat(obj.productDetails.APR), 2, true)}}% {{text[2]}} {{toFixed(parseFloat(obj.productDetails.APR), 1)}}% {{text[0]}}</p>
            </div>
        </div>
        <div v-else-if="res == 1" id="resfailed">
            <!-- <img id="creditwise" alt="" :src="require(`@/v1/assets/images/creditwise.png`)"/>
            <h2>{{obj.title}}</h2>
            <p>{{obj.desc}}</p>
            <ticklist :obj="obj.bullets"></ticklist>
            <button id="creditWiseBtn" @click="creditWise(obj.link)">CreditWise</button> -->
        </div>
        <div v-else id="resfailed">
            <p>Please try again later</p>
            <button id="backBtn" onclick="location.reload()">Back to QuickCheck</button>
        </div>
    </div>
</template>

<script>
/*eslint-disable */
import ticklist from './ticklist.vue'

export default {
    name: 'resMain',
    components: {
        ticklist
    },
    props: {
        res: Number,
        obj: Object,
        token: String,
        id: String,
        text: Array,
        url: String,
        bin: String
    },
    methods: {
        toFixed(number, decimals, pad) {
            var re = new RegExp('^-?\\d+(?:.\\d{0,' + (decimals || -1) + '})?');
            var fixed = number.toString().match(re)[0];

            if (pad !== true) {
                return fixed;
            }

            var numberValue = Number(fixed);

            if (String(numberValue).split(".").length < 2 || String(numberValue).split(".")[1].length <= 2) {
                numberValue = numberValue.toFixed(2);
            }

            return numberValue;
        },
        applyNow: function(a, b, c, d) {
            let apply_url = d.replace(c, encodeURIComponent(c)).replace("PRODUCT_ID_REPLACE", a).replace("V_REPLACE", sourcecode);

            let check_campaign = urlParam('campaign');

            if(check_campaign !== null){
                apply_url = apply_url + `&campaign=${check_campaign}`
            }

            let check_pcr = urlParam('pcr');

            if(check_pcr !== null){
                apply_url = apply_url + `&pcr=${check_pcr}`
            }
            
            location.href = apply_url
        },
        creditWise: function(a) {
            location.href = a;
        },
        genBullets: function(a) {
            var cardbullets = [
                "£" + a.minCreditLimit + " to £" + a.maxCreditLimit + " credit limit"
            ];
            if (a.BTIntroRates !== "N/A") {cardbullets.push(a.BTIntroRates);}
            if (a.PTIntroRates !== "N/A") {cardbullets.push(a.PTIntroRates);}
            if (a.NSTFee !== "N/A") {cardbullets.push(a.NSTFee);}
            return cardbullets;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .formsect {
        position: relative;
        bottom: 5.5em;
        margin-bottom: 0px;
        background-color: #FFF;
    }
    .inline:nth-of-type(1) {
        max-width: 20em;
    }
    #resfailed {
        text-align: center;
    }
    #resfailed h2 {
        margin: 0.75em 0px;
    }
    #resfailed p {
        bottom: 0px;
        margin: 0 auto;
        margin-bottom: 1em;
        font-size: 1.1em;
        max-width: 750px;
        line-height: 1.375em;
    }
    #resfailed p:nth-child(1) {
        margin-bottom: 0.5em;
        font-size: 1.5em;
    }
    #resfailed ul {
        margin: 0 auto;
        max-width: 550px;
        text-align: left;
    }
    h3 {
        font-weight: normal;
    }
    h3 strong {
        font-size: 1.2em;
    }
    img {
        margin-top: 0.5em;
        width: 100%;
    }
    img#creditwise {
        width: 12.5em;
    }
    button {
        margin-top: 1.25em;
        padding: 1em;
        border: 0px;
        border-radius: 4em;
        color: #FFF;
        background-color: #e51635;
        font-family: ProbaPro;
        font-size: 1em;
        font-weight: bold;
        width: 15em;
    }
    button:not(#backBtn):after {
        content: ">";
        position: relative;
        bottom: 0.125em;
        display: inline-block;
        padding-left: 0.5em;
        font-weight: normal;
        transform: scale(1.75, 2.5);
    }
    button:hover, button:focus {
        background-color: #ba112d;
        outline: 0px;
        cursor: pointer;
    }
    .examplerep {
        margin-top: 1.5em;
        padding: 1.25em 3em;
        border: 1px solid #bbb;
        border-radius: 0.5em;
        font-size: 1.1em;
    }
    .examplerep * {
        margin: 0px;
        bottom: 0px;
        line-height: 1.375em;
    }
    @media screen and (min-width: 801px) {
        .inline {
            display: inline-block;
            vertical-align: top;
        }
        .inline:nth-of-type(2) {
            padding-left: 3em;
            width: calc(100% - 24em);
        }
    }
    @media screen and (max-width: 800px) {
        .inline:nth-of-type(1) {
            margin: 0 auto;
            text-align: center;
        }
        .inline:nth-of-type(2) button {
            position: relative;
            top: 1.5em;
            display: block;
            margin: 0 auto;
        }
    }
    @media screen and (max-width: 659px) {
        .examplerep {
            padding: 1.25em 1.5em;
        }
    }
</style>